import { render, staticRenderFns } from "./AdmissionResult.vue?vue&type=template&id=1f50fae3&scoped=true"
import script from "./AdmissionResult.vue?vue&type=script&lang=js"
export * from "./AdmissionResult.vue?vue&type=script&lang=js"
import style0 from "./AdmissionResult.vue?vue&type=style&index=0&id=1f50fae3&prod&lang=css"
import style1 from "./AdmissionResult.vue?vue&type=style&index=1&id=1f50fae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f50fae3",
  null
  
)

export default component.exports